import PropTypes from 'prop-types';
import React from 'react';
import { Box, Chip } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

import { AssociationStatusLabel } from 'enums/SigManagement.enum';

const statusLabel = (isActive) =>
  isActive ? AssociationStatusLabel.ACTIVE : AssociationStatusLabel.INACTIVE;

const StatusChip = ({ isActive, dimmed }) => (
  <Chip
    size='small'
    variant={isActive ? 'filled' : 'outlined'}
    color={isActive ? 'success' : 'default'}
    label={statusLabel(isActive)}
    sx={{ fontWeight: 500, opacity: dimmed ? 0.6 : 1 }}
  />
);

StatusChip.propTypes = { isActive: PropTypes.bool, dimmed: PropTypes.bool };
StatusChip.defaultProps = { isActive: false, dimmed: false };

/**
 * One association's status — and, when a change is staged against it, both sides of that change.
 *
 * A staged row used to show its pending status as a single chip, so a direction about to be set
 * inactive read "Inactive", which is indistinguishable from one that already is. Showing
 * "Active → Inactive" says where it is and where it is going, and cannot be mistaken for a fact.
 *
 * Shared by both cards so a direction and a catalog item never describe the same state two
 * different ways.
 */
const AssociationStatusChip = ({ isActive, serverIsActive, isStaged }) => {
  if (!isStaged) {
    return <StatusChip isActive={isActive} />;
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <StatusChip isActive={serverIsActive} dimmed />
      <ArrowForwardIcon fontSize='small' sx={{ color: 'text.disabled' }} />
      <StatusChip isActive={isActive} />
    </Box>
  );
};

export default AssociationStatusChip;

AssociationStatusChip.propTypes = {
  isActive: PropTypes.bool,
  serverIsActive: PropTypes.bool,
  isStaged: PropTypes.bool,
};

AssociationStatusChip.defaultProps = {
  isActive: false,
  serverIsActive: false,
  isStaged: false,
};

export { statusLabel };
